import axios from '../http'
import global from '@/constants/Global.constants'

export default {
    getCaseList(params) { // 获取案例列表
        return axios.post(global.CMS_CASE + '/findAllWebCase', params)
    },
    getCaseTypeList(params) { // 获取案例类型列表
        return axios.post(global.CMS_CASETYP + '/findAllWebCaseType', params)
    },
    getCaseListByProductInfoId(params) { // 根据商品infoId获取案例列表findAllWebCase
        return axios.post(global.CMS_CASE + '/findAllWebCaseByProductInfoId', params)
    },
    getWebAdpic(params) { // 获取轮播图
        return axios.post(global.CMS_WY + '/adpic/findWebAdpic', params)
    }
}


// WEBPACK FOOTER //
// ./src/request/cms/case.js